import {ArrowLeftOutlined} from '@ant-design/icons';
import {Button} from 'antd';
import React from 'react';

interface IProps {
  text: string;
  callback: any;
  color?: string;
}

const BackButtonWText: React.FC<IProps> = (props) => {
  const {text, callback, color} = props;
  return (
    <Button
      data-testid="back-button"
      type="link"
      icon={<ArrowLeftOutlined />}
      onClick={() => callback()}
      style={{paddingLeft: 0, ...(color && {color})}}>
      <span data-testid="back-button-text" style={{textDecoration: 'underline'}}>
        {text}
      </span>
    </Button>
  );
};

export default BackButtonWText;
